import styled from "styled-components";

export const Image = styled.img`
    width: 70%;
    cursor: pointer !important;
    padding: 25px;
    border-radius: 40px;
    overflow: scroll;
    height: fit-content;
`

export const ButtonDiv = styled.button`
    margin-left: auto;
    flex-shrink: 0;
    background: rgba(255, 64, 110, 0.3);
    border: none;
    border-radius: 13px;
    width: 26px;
    height: 26px;
    color: rgba(255, 64, 110, 0.86);
`
